import { Component, Input, output } from  '@angular/core';
import { GridComponent } from '../cockpitDesigner.models';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';  
import { ComponentForms } from '../../cockpitComponents/index';
import { CommonModule } from '@angular/common';
import { PushButtonFormComponent } from '../../cockpitComponents/PushButton/PushButtonFom/PushButtonForm.component';
import { gridComponents } from '../cockpitDesigner.component';

@Component({
  selector: 'app-designer-component-settings',
  templateUrl: 'component.settings.component.html',
  styleUrl: 'component.settings.component.css',
  imports:[ MatButtonModule,MatIconModule, CommonModule, PushButtonFormComponent ]
})

export class DesignerComponentSettings {

  @Input() selectedComponent:{gridComponent: GridComponent, rowId: string, columnId:string} | null = null; 
  closeComponentSettings = output();
  pushButtonIdChange=output<string>();
  pushButtonNameChange=output<string>();
  handleComponentChange=output<GridComponent>()
  componentForms = ComponentForms;

  onClose(event:any){
    this.closeComponentSettings.emit();
  }

  handleIdChangePushButton(event: string, field:string){
    if(!this.selectedComponent) return; 
    const newComponent: GridComponent = {
      ...this.selectedComponent.gridComponent,
      componentSettings:{
      ...this.selectedComponent?.gridComponent.componentSettings,
       [field]: event
      }
    }
    this.handleComponentChange.emit(newComponent)
    this.pushButtonIdChange.emit(event);
  }

   componentFieldChange(event:{value:string, field:string}){
    if(!this.selectedComponent) return; 
    const newComponent: GridComponent = {
      ...this.selectedComponent.gridComponent,
      componentSettings:{
      ...this.selectedComponent?.gridComponent.componentSettings,
       [event.field]: event.value
      }
    }
    this.handleComponentChange.emit(newComponent)
    //this.pushButtonIdChange.emit(event.field);
  }

  handleNameChangePushButton(event: string, field: string){
    this.pushButtonIdChange.emit(event);
  }

}